import apiClient from "./ApiInterceptor";

export const getHighlightSections = async (start_date, end_date) => {
    const params = {};
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    const response = await apiClient.get('/highlightSections', { params } );
    return response;
}

export const createHighlightSection = async (data) => {
    const response = await apiClient.post('/highlightSections', data);
    return response;
}

export const updateHighlightSection = async (id, data) => {
    const response = await apiClient.put(`/highlightSections/${id}`, data);
    return response;
}

export const deleteHighlightSection = async (id) => {
    const response = await apiClient.delete(`/highlightSections/${id}`);
    return response;
}
